import React from 'react';

const Logo = ({ size = "default", className = "", textColor = "text-primary-blue" }) => {
  const dimensions = {
    small: { width: "60", height: "auto" },
    default: { width: "80", height: "auto" },
    large: { width: "100", height: "auto" }
  };

  const { width, height } = dimensions[size];

  return (
    <div className={`flex items-center ${className}`}>
      {/* HCP Professional Logo - High Quality Version */}
      <img
        src="/logo.png"
        alt="Here Comes Protection — Home, Auto & Business Insurance"
        style={{
          width: width,
          height: 'auto',
          maxWidth: '100%',
          objectFit: 'contain'
        }}
        className="rounded-lg"
      />
    </div>
  );
};

export default Logo;